import React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="c">
        <stop stopColor="#F88E51" offset="0%" />
        <stop stopColor="#FF4519" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#FFAD7C" offset="0%" />
        <stop stopColor="#FF795B" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.078%"
        y1="25.222%"
        x2="91.089%"
        y2="76.688%"
        id="d"
      >
        <stop stopColor="#FFE9E1" offset="0%" />
        <stop stopColor="#FFE9E1" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fillRule="evenodd">
      <path
        d="M29 6c6.35 0 12.1 2.59 16.261 6.774A23.132 23.132 0 0 1 52 29.136c0 5.526-3.422 12.305-7.652 18.275C38.784 55.26 31.73 62 29 62c-2.73 0-9.784-6.74-15.348-14.59C9.422 41.442 6 34.663 6 29.137c0-6.39 2.575-12.174 6.739-16.362C16.9 8.59 22.649 6 29 6Z"
        stroke="url(#b)"
        strokeWidth={2}
        fill="url(#c)"
      />
      <path
        d="M2.643 12.27H1.62C.725 12.27 0 11.662 0 10.91V9.165c0-.751.725-1.359 1.62-1.359h1.013c.463-2.583 1.924-4.652 4.44-6.168C8.929.521 11.028.011 13.303 0 17.798-.02 23.017 2.75 23.842 7.8h1.157c.895 0 1.62.608 1.62 1.358v1.737c0 .75-.725 1.358-1.62 1.358h-1.012l-1.225 8.852c-.095.686-.787 1.203-1.61 1.204H5.414c-.827.001-1.52-.52-1.612-1.21L2.643 12.27Zm18.06-4.008c-.427-2.963-3.413-5.834-7.47-5.783-4.224.054-6.94 3.07-7.318 5.783h14.788ZM9.86 19.002V13.22H6.9v5.784h2.958Zm9.858-5.783H16.76v5.784h2.957v-5.784Z"
        transform="translate(16.09 18.385)"
        fill="url(#d)"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
